import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DescriptionIcon from "@material-ui/icons/DescriptionOutlined";
import clsx from "clsx";
import palette from "../../../theme/palette";

import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";

import Paper from "@material-ui/core/Paper";
import AddFilesDialog from "./components/AddFilesDialog";
import { withRouter } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto"
  },
  mainheading: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(2),
    alignItems: "center",
    display: "flex"
  },
  heading: {
    marginBottom: theme.spacing(3)
  },

  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  iconRight: {
    marginRight: "1.2rem"
  },
  paper: {
    width: "100%",
    height: "100%",
    padding: "2.5rem"
  },
  greenPaper: {
    backgroundColor: palette.secondary.light,
    boxShadow: "none"
  },
  contactFormPaper: {
    maxWidth: "71.5rem"
  },
  bigAvatar: {
    marginRight: theme.spacing(3),
    width: 92,
    height: 92
  },
  flexDiv: {
    display: "flex",
    alignItems: "center"
  },
  flexCol: {
    display: "flex",
    flexDirection: "column"
  },
  button: {
    alignSelf: "flex-end"
  }
}));

function AdminPage(props) {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  function handleOpen() {
    setOpen(!open);
  }
  return (
    <main className={classes.content}>
      <div className={classes.appBarSpacer} />

      <Container maxWidth="xl" className={classes.container}>
        <Grid container spacing={0}>
          <Grid container spacing={3} className={classes.centerVert}>
            <Grid item xs={12} align="left">
              <Typography
                variant="h3"
                component="h3"
                align="left"
                className={classes.mainheading}
              >
                <DescriptionIcon className={classes.iconRight} /> Administrer
                retningslinjer
              </Typography>
            </Grid>
            <Grid item xs={12} align="left">
              <Paper className={clsx(classes.greenPaper, classes.paper)}>
                <Typography
                  color="textPrimary"
                  className={classes.depositContext}
                >
                  Her har du som administrator muligheten til å legge
                  til/redigere feature-modul og forsidenyheter, i tillegg til å
                  administrere partnere, brukere og retningslinjer.
                </Typography>
              </Paper>
            </Grid>

            <Grid item xs={12} align="left">
              <Paper className={classes.paper}>
                <Grid container spacing={3} className={classes.centerVert}>
                  <Grid item xs={12} align="left">
                    <Typography
                      color="textPrimary"
                      className={classes.depositContext}
                    >
                      <a href="http://www.norsk-tipping.no">
                        Retningslinje for markedsføring
                      </a>
                      <br />
                      <br />

                      <a href="http://www.norsk-tipping.no">
                        Retningslinje for natives
                      </a>
                      <br />
                      <br />

                      <a href="http://www.norsk-tipping.no">
                        Avtale Nettpartner Portal
                      </a>
                      <br />
                      <br />

                      <a href="http://www.norsk-tipping.no">
                        Krav til Teknisk løsning og Support
                      </a>
                      <br />
                      <br />

                      <a href="http://www.norsk-tipping.no">
                        Taushetserklæring-norsk
                      </a>
                      <br />
                      <br />

                      <a href="http://www.norsk-tipping.no">
                        Bestemmelser om Markedsføring
                      </a>
                      <br />
                      <br />

                      <a href="http://www.norsk-tipping.no">
                        Merking av transaksjoner
                      </a>
                      <br />
                      <br />

                      <a href="http://www.norsk-tipping.no">
                        Policy for ansvarlig spill
                      </a>
                      <br />
                      <br />

                      <a href="http://www.norsk-tipping.no">
                        Retningslinjer for Nettpartnere
                      </a>

                      <br />
                      <br />
                    </Typography>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleOpen}
                    >
                      <AddIcon /> LEGG TIL NY
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
        <AddFilesDialog open={open} handleClose={handleOpen} />
      </Container>
    </main>
  );
}

export default withRouter(AdminPage);
